import { getDocument } from './environment';

export enum FooterType {
  default = 0,
  none = 1
}

interface ExposedReportError {
  message: string;
}

interface ExposedReportData {
  ready?: boolean;
  csvData?: string;
  error?: ExposedReportError;
}

interface ReportDocument extends Document {
  reportData: ExposedReportData;
  footerType: FooterType;
}

const reportData: ExposedReportData = {};
(<ReportDocument>getDocument()).reportData = reportData;
(<ReportDocument>getDocument()).footerType = FooterType.default;

export const setFooterType = (footerType: FooterType = FooterType.default): void => {
  (<ReportDocument>getDocument()).footerType = footerType;
};

export const setReadyState = (): void => {
  reportData.ready = true;
};

export const setCSVData = (csvData: string): void => {
  reportData.csvData = csvData;
};

export const setError = (message: string): void => {
  reportData.error = { message };
};
